import React from 'react';
import ProductIconFixedTerm from '@raisin/components-lib/Icons/FixedTerm';
import ProductIconOvernightMoney from '@raisin/components-lib/Icons/OvernightMoney';
import ProductIconETFConfigurator from '@raisin/components-lib/Icons/EtfConfigurator';
import ProductIconWealthManagement from '@raisin/components-lib/Icons/WealthManagement';
import { ProductCategoryProps } from './types';

export const getProductCategoryItems = (bodyCopies: ProductCategoryProps['body_copies']) => {
  if (bodyCopies.length < 4) return null;

  const productCategoryItems = [
    {
      title: 'Festgeld',
      body: '',
      svg: <ProductIconFixedTerm />,
      totalItem: 4,
      buttonLabel: 'Jetzt sparen',
      href: 'https://www.weltsparen.de/festgeld/',
    },
    {
      title: 'Tagesgeld',
      body: '',
      svg: <ProductIconOvernightMoney />,
      totalItem: 4,
      buttonLabel: 'Jetzt sparen',
      href: 'https://www.weltsparen.de/tagesgeld/',
    },
    {
      title: 'Vermögensverwaltung',
      body: '',
      svg: <ProductIconWealthManagement />,
      totalItem: 4,
      buttonLabel: 'Jetzt investieren',
      href: 'https://www.weltsparen.de/vermoegensverwaltung/',
    },
    {
      title: 'ETF Rürup',
      body: '',
      svg: <ProductIconETFConfigurator />,
      totalItem: 4,
      buttonLabel: 'Jetzt investieren',
      href: 'https://www.weltsparen.de/etf-ruerup/',
    },
  ];

  bodyCopies.forEach((item: { copy: string }, index: string | number) => {
    productCategoryItems[index]['body'] = item.copy;
  });

  return productCategoryItems;
};
